<template>
	<div class="logo">
		<div class="logo__symbol">
			<svg
				version="1.1"
				viewBox="0 0 79.6 57"
				xmlns="http://www.w3.org/2000/svg">
				<g>
					<g id="Layer_1">
						<g
							id="Layer_1-2"
							data-name="Layer_1">
							<path
								d="M74.5,37.9h-23.5l20.2-30.7c.6-1.1.3-2.2-.4-2.9-.7-.7-1.8-1-2.9-.4l-31.4,19.5L24.3,4.7c-1.3-2-4.4-1.1-4.4,1.3v31.9H3.2v16.7h16.7v-16.7h16.7v16.7h16.7l22.4-12.2c2.2-1.2,1.3-4.5-1.1-4.5h-.1Z" />
						</g>
					</g>
				</g>
			</svg>
		</div>
		<div class="logo__text">
			<svg
				id="Layer_1"
				version="1.1"
				viewBox="0 0 399.5 57"
				xmlns="http://www.w3.org/2000/svg">
				<g
					id="Layer_11"
					data-name="Layer_1">
					<g>
						<path
							d="M21.2,47.4c-3.1,0-5.5-1-7.3-3s-2.7-4.8-2.7-8.3.9-6.4,2.7-8.3c1.8-2,4.2-3,7.3-3s4.2.5,5.6,1.5c1.5,1,2.5,2.4,3.1,4.3h8c-.9-4-2.7-7.1-5.7-9.3-2.9-2.2-6.6-3.3-11-3.3s-6.8.7-9.4,2.2c-2.7,1.5-4.8,3.6-6.2,6.3-1.5,2.7-2.2,5.9-2.2,9.6s.7,6.9,2.2,9.6c1.5,2.7,3.6,4.8,6.3,6.3,2.7,1.5,5.8,2.2,9.4,2.2s8.4-1.1,11.3-3.4c2.9-2.3,4.8-5.6,5.5-9.8h-8c-1.1,4.2-4,6.4-8.9,6.4Z" />
						<path
							d="M67.2,20.1c-2.7-1.5-6-2.2-9.7-2.2s-7,.7-9.7,2.2c-2.8,1.5-4.9,3.6-6.4,6.3s-2.2,5.9-2.2,9.6.8,6.9,2.3,9.6c1.5,2.7,3.6,4.8,6.4,6.3,2.7,1.5,6,2.2,9.7,2.2s7-.7,9.7-2.2,4.8-3.6,6.3-6.3,2.2-6,2.2-9.7-.7-7-2.2-9.7-3.6-4.8-6.3-6.3v.2ZM65.1,44.3c-1.8,2-4.4,3-7.7,3s-5.8-1-7.6-3-2.7-4.8-2.7-8.3.9-6.3,2.7-8.3,4.4-3,7.6-3,5.9,1,7.7,3,2.7,4.7,2.7,8.3-.9,6.3-2.7,8.3Z" />
						<path
							d="M114,4.5h-7.9v19.2h-.2c-1-1.9-2.5-3.4-4.5-4.4-1.9-1-4.3-1.5-7-1.5s-6.2.7-8.5,2.2c-2.4,1.5-4.2,3.6-5.5,6.3s-1.9,6-1.9,9.7.6,6.9,1.9,9.6c1.3,2.7,3.2,4.8,5.7,6.3s5.5,2.2,9,2.2,5.3-.5,7.4-1.6c2-1.1,3.7-2.6,4.9-4.6h2.5v5.5h8.2v-8h-4V4.5h0ZM106,38.1c0,2.8-.9,5.1-2.6,6.8-1.8,1.7-4.1,2.5-7.1,2.5s-5.7-1-7.4-3-2.6-4.8-2.6-8.3.9-6.3,2.6-8.3c1.7-2,4.2-3,7.4-3s5.3.8,7.1,2.5,2.6,3.9,2.6,6.8v4.2-.2Z" />
						<path
							d="M147.5,19.9c-2.5-1.4-5.5-2.1-9-2.1s-6.8.7-9.5,2.2-4.8,3.6-6.2,6.3c-1.5,2.7-2.2,5.9-2.2,9.6s.7,6.9,2.2,9.7,3.6,4.9,6.3,6.4,6,2.2,9.7,2.2,8-1,10.9-3.1c2.9-2,4.8-4.9,5.6-8.5h-8.1c-.5,1.7-1.5,3-3,3.9-1.4.9-3.3,1.3-5.5,1.3s-5.5-.9-7.4-2.6c-1.8-1.7-2.9-4.2-3.2-7.4h27.3v-2.9c0-3.5-.7-6.5-2.1-9.1-1.4-2.5-3.3-4.5-5.9-5.9h0ZM128.4,32.2c.5-2.6,1.7-4.5,3.4-5.9,1.8-1.4,4-2.1,6.6-2.1s4.8.7,6.5,2.1c1.6,1.4,2.6,3.4,2.9,5.9h-19.5.1Z" />
						<path
							d="M176,47.4c-3.1,0-5.5-1-7.3-3s-2.7-4.8-2.7-8.3.9-6.4,2.7-8.3c1.8-2,4.2-3,7.3-3s4.2.5,5.6,1.5c1.5,1,2.5,2.4,3.1,4.3h8c-.9-4-2.7-7.1-5.7-9.3-2.9-2.2-6.6-3.3-11-3.3s-6.8.7-9.4,2.2c-2.7,1.5-4.8,3.6-6.2,6.3-1.5,2.7-2.2,5.9-2.2,9.6s.7,6.9,2.2,9.6c1.5,2.7,3.6,4.8,6.3,6.3s5.8,2.2,9.4,2.2,8.4-1.1,11.3-3.4c2.9-2.3,4.8-5.6,5.5-9.8h-8c-1.1,4.2-4,6.4-8.9,6.4Z" />
						<path
							d="M228.7,31.4c0-4.4-1.3-7.7-4-10.1-2.6-2.3-6.5-3.5-11.5-3.5s-8.1,1-10.9,2.9-4.5,4.7-5.2,8.3h7.9c.9-3.2,3.6-4.8,8.1-4.8s7.9,2.3,7.9,7v1.5h-11.1c-4.4,0-7.7.9-10,2.8-2.3,1.9-3.5,4.5-3.5,7.9s1.2,5.8,3.5,7.8,5.5,3,9.5,3,5.4-.5,7.5-1.6,3.7-2.6,4.9-4.5h2.4v5.5h8.2v-8h-3.8v-14.2h.1ZM221.1,39.4c0,1.6-.5,3-1.4,4.3s-2.2,2.3-3.8,3.1c-1.6.8-3.4,1.2-5.4,1.2s-3.7-.4-4.8-1.3c-1.2-.9-1.8-2.1-1.8-3.6,0-3.2,2.1-4.8,6.4-4.8h10.7v1.1h0Z" />
						<path
							d="M257.1,17.9c-3,0-5.5.5-7.6,1.6s-3.7,2.6-5,4.6h-2.5v-5.5h-8.3v8h4v27h7.9v-19.8c0-2.9.8-5.1,2.3-6.6s3.8-2.3,6.8-2.3,5.3.8,6.8,2.3,2.3,3.7,2.3,6.6v19.8h7.9v-21.2c0-4.4-1.3-7.9-3.9-10.5s-6.3-3.9-10.9-3.9h.2Z" />
						<path
							d="M299.5,17.9c-3,0-5.5.5-7.6,1.6s-3.7,2.6-5,4.6h-2.5v-5.5h-8.3v8h4v27h7.9v-19.8c0-2.9.8-5.1,2.3-6.6s3.8-2.3,6.8-2.3,5.3.8,6.8,2.3,2.3,3.7,2.3,6.6v19.8h7.9v-21.2c0-4.4-1.3-7.9-3.9-10.5s-6.3-3.9-10.9-3.9h.2Z" />
						<path
							d="M346.8,20.1c-2.7-1.5-6-2.2-9.7-2.2s-7,.7-9.7,2.2c-2.8,1.5-4.9,3.6-6.4,6.3s-2.2,5.9-2.2,9.6.8,6.9,2.3,9.6c1.5,2.7,3.6,4.8,6.4,6.3,2.7,1.5,6,2.2,9.7,2.2s7-.7,9.7-2.2,4.8-3.6,6.3-6.3,2.2-6,2.2-9.7-.7-7-2.2-9.7-3.6-4.8-6.3-6.3v.2ZM344.7,44.3c-1.8,2-4.4,3-7.7,3s-5.8-1-7.6-3c-1.8-2-2.7-4.8-2.7-8.3s.9-6.3,2.7-8.3c1.8-2,4.4-3,7.6-3s5.9,1,7.7,3c1.8,2,2.7,4.7,2.7,8.3s-.9,6.3-2.7,8.3Z" />
						<path
							d="M392.1,21.8c-2.6-2.6-6.3-3.9-10.9-3.9s-5.5.5-7.6,1.6-3.7,2.6-5,4.6h-2.5v-5.5h-8.3v8h4v27h7.9v-19.8c0-2.9.8-5.1,2.3-6.6s3.8-2.3,6.8-2.3,5.3.8,6.8,2.3,2.3,3.7,2.3,6.6v19.8h7.9v-21.2c0-4.4-1.3-7.9-3.9-10.5h.2Z" />
					</g>
				</g>
			</svg>
		</div>
	</div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.logo {
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	justify-content: center;

	.logo__symbol {
		width: 15%;
		svg {
			@media all {
				fill: var(--p-yellow-500);
			}
		}
	}

	.logo__text {
		width: 85%;
		svg {
			@media all {
				fill: var(--p-yellow-500);
			}
		}
	}
}
</style>
